module.exports = __webpack_public_path__ + "img/data-folder-svgrepo-com.f931fa36.svg";